import { apiRequest ,getAuthHeader} from "./apiHelper";

// Add a new deal to a stage
export const addDeal = async (pipelineId, stageId, dealData) => {
  return apiRequest("post", `/deal/create-deal-v1`, dealData);
};

// Edit an existing deal
export const editDeals = async (dealId, dealData) => {
  return apiRequest("patch", `/deal/update-deal-v1/${dealId}`, dealData);
};

// Move a deal to a different stage (on drag and drop)
export const moveDealToStage = async (dealId, newStageId) => {
  return apiRequest("patch", `/deal/update-deal/${dealId}`, {
    stageId: newStageId,
  });
};



// Add a new stage to a pipeline
export const addStage = async (pipelineId, stageData) => {
  return apiRequest("post", `/stage/create-stage`, stageData);
};

// Get all pipelines
// export const getPipelines = async (userId, startDate, endDate) => {
//   const params = new URLSearchParams();
//   if (userId) params.append('userId', userId);
//   if (startDate) params.append('startDate', startDate);
//   if (endDate) params.append('endDate', endDate);
//   const queryString = params.toString();
//   const endpoint = queryString ? `/pipeline/get-all-pipelines-optimized-v4?${queryString}` : '/pipeline/get-all-pipelines-optimized-v4';
//   return apiRequest("get", endpoint);
// }

// Get all pipelines
export const getPipelines = async (userId, extraParams = {}) => {
  // Call the unified endpoint `/pipeline/get-all-pipelines-v1` and pass
  // `userId`, `startDate`, `endDate` in query params so backend's
  // `getAllPipelines_optimized_v4` (which reads req.query) can apply date filters.
  const params = {};
  if (userId) params.userId = userId;
  if (extraParams) {
    if (extraParams.startDate) params.startDate = extraParams.startDate;
    if (extraParams.endDate) params.endDate = extraParams.endDate;
  }
  return apiRequest("get", `/pipeline/get-all-pipelines-v1`, {}, { params });
};

// Get all deals for a pipeline
export const getDealsForPipeline = async (pipelineId) => {
  return apiRequest("get", `/deal/get-deals/${pipelineId}`);
};

// (Optional) Get all deals (if endpoint exists)
export const getDeals = async () => {
  return apiRequest("get", "/pipeline/get-deals/");
};

// Convert a lead to a deal
export const convertLeadToDeal = async (payload) => {
  return apiRequest("post", "/deal/convert", payload);
};
